'use client';
import { PropsWithChildren } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { EquipmentInfoProps, RequestServiceDateProps } from '../types';

interface Props {
  id?: string;
  formMethods: UseFormReturn<{
    equipment: EquipmentInfoProps;
    requestDescription: string;
    requestDealerName: string;
    requestDealerCode: string;
    requestServiceStoreId: string;
    preferredDateTime: {
      time: string;
      dates: Array<RequestServiceDateProps>;
      type: string;
      month: Date;
    };
    customer: {
      companyName: string;
      contactName: string;
      contactMethod: string;
      email: string;
      phone: string;
      customerName: string;
      ccidProd: string;
    };
  }>;
  handleSubmit: () => void;
}

export const RequestServiceForm = ({
  id,
  children,
  formMethods,
  handleSubmit
}: PropsWithChildren<Props>) => {
  return (
    <FormProvider {...formMethods}>
      <form id={id} onSubmit={handleSubmit}>
        {children}
      </form>
    </FormProvider>
  );
};
